import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const AdminLayout = ({ notifications = [] }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-[#f4ede2]">
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        collapsed={false}
        setCollapsed={() => {}}
      />

      <div className="flex flex-col flex-1 overflow-hidden lg:pl-[280px]">
        <Navbar
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
          notifications={notifications}
          sidebarCollapsed={false}
        />

        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="min-h-screen">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
